/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementCreateGroupResponse } from "./GroupManagementCreateGroupResponse";

export type GroupManagementCreateGroupResponseApiRespoonse = {
  data?: GroupManagementCreateGroupResponse;
  status?: GroupManagementCreateGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementCreateGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
